<template>
  <div>
    <div class="box">
      <BInputText
        label-text="APP标识"
        :required="true"
        v-model="addParams.appId"
        :maxLength="20"
        :disabled="true"
        placeholder="请输入APP标识"
      />
      <BInputPullDown
        label-name="手机类型"
        :required="true"
        :value="addParams.appType"
        v-model="addParams.appType"
        :Options="appTypeList"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="版本号"
        :required="true"
        v-model="addParams.version"
        :maxLength="20"
        placeholder="请输入版本号（例：0.1.1）"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="文件地址"
        :required="true"
        v-model="addParams.fileUrl"
        :maxLength="255"
        placeholder="请输入文件地址"
        :inputLength="400"
        disabled
      />
      <span style="margin-left:20px">
        <BBtnPrimary
          :img-src="require('@/assets/new.png')"
          :clicked="fileAdd"
          btn-txt="添加文件"
        />
      </span>
    </div>
    <div class="box1">
      <BInputPullDown
        label-name="更新标识"
        :required="true"
        v-model="addParams.updateFlg"
        :value="addParams.updateFlg"
        :Options="updateList"
      />
      <BInputPullDown
        label-name="启用标识"
        :required="true"
        v-model="addParams.enableFlg"
        :value="addParams.enableFlg"
        :Options="enableList"
      />
    </div>
    <div class="box2">
      <label class="labelClass"
        >备注<span style="color:#FC1111;">*</span></label
      >
      <BInputTextArea
        label-text="备注"
        class="area-class"
        v-model="addParams.remarks"
        placeholder="请输入备注"
        :maxLength="255"
      />
    </div>

    <div class="box2">
      <BBtnPrimary v-if="editFlg == '0'" :clicked="handleAdd" btn-txt="保存" />
      <BBtnPrimary v-else :clicked="handleEdit" btn-txt="修改" />
      <BBtnPrimary :clicked="upConfirmSuccess" btn-txt="返回" />
    </div>
  </div>
</template>
<script>
import {
  versionAddInit,
  saveVersion,
  versionUpdate,
  versionDetail,
} from "@/api/appVersionUpdate";
import BInputText from "../../components2/BInputText";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputPullDown from "../../components2/BInputPullDown";
import BInputTextArea from "../../components2/BInputTextArea";
import fileAdd from "../../views2/sample/AppVersionFileAdd";
import Vue from "vue";
import Hub from '../../events/Hub';

export default {
  components: {
    BInputText,
    BBtnPrimary,
    BInputPullDown,
    BInputTextArea,
  },
  data: () => ({
    addParams: {
      appId: "",
      appType: "",
      version: "",
      fileUrl: "",
      updateFlg: "",
      enableFlg: "",
    },
    data:null,
    items: [],
    checked: [],
    appTypeList: [],
    updateList: [],
    enableList: [],
    editFlg: "0",
    versionId: null,
    navi: [{ name: "app-version-management" }, { name: "app-version-add" }],
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted(){
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 页面初期化
      vm.editFlg = vm.$route.params.editFlg;
      vm.versionId = vm.$route.params.versionId;
      if (
        (vm.editFlg !== undefined &&
          vm.editFlg !== null &&
          vm.editFlg !== "") ||
        (vm.versionId !== undefined &&
          vm.versionId !== null &&
          vm.versionId !== "")
      ) {
        // 把不为空的参数存入缓存
        const storageParams = {
          editFlg: vm.editFlg,
          versionId: vm.versionId,
        };
        vm.$store.commit("SET_VERSION_ADD_PARAMS", storageParams);
      }
      // 查询条件赋值
      if (
        (vm.$store.state.versionAdd_editFlg !== undefined &&
          vm.$store.state.versionAdd_editFlg !== null &&
          vm.$store.state.versionAdd_editFlg !== "") ||
        (vm.$store.state.versionAdd_versionId !== undefined &&
          vm.$store.state.versionAdd_versionId !== null &&
          vm.$store.state.versionAdd_versionId !== "")
      ) {
        vm.editFlg = vm.$store.state.versionAdd_editFlg;
        vm.versionId = vm.$store.state.versionAdd_versionId;
      }
      vm.init();
      if (vm.editFlg == "1") {
        vm.detail();
      }
    });
  },
  methods: {
    // 添加文件
    // 添加资料按钮
    fileAdd() {
      Hub.$emit('open-modal');
      Hub.$emit('set-modal-data', this.data, '添加文件', fileAdd);
    },
    // 初始化
    async init() {
      const data = await versionAddInit();
      this.addParams.appId = "__ZPT__SCBBX";
      this.appTypeList = data.data.appTypeList;
      this.addParams.appType = 'android';
      this.updateList = data.data.updateList;
      this.addParams.updateFlg = '1';
      this.enableList = data.data.enableList;
      this.addParams.enableFlg = '1';
    },
    async detail() {
      var params = {
        id: this.versionId,
      };
      const data = await versionDetail(params);
      if (data.data) {
        this.addParams = data.data;
      }
    },
    handleAdd() {
      if (!this.addParams.appId) {
        Vue.prototype.$valertbar.show("请输入APP标识");
        return;
      }
      if (!this.addParams.appType) {
        Vue.prototype.$valertbar.show("请输入手机类型");
        return;
      }
      if (!this.addParams.version) {
        Vue.prototype.$valertbar.show("请输入版本号");
        return;
      }
      if (!this.addParams.fileUrl) {
        Vue.prototype.$valertbar.show("请输入文件地址");
        return;
      }
      if (!this.addParams.remarks) {
        Vue.prototype.$valertbar.show("请输入备注");
        return;
      }
      if (this.addParams.remarks.length > 255) {
        Vue.prototype.$valertbar.show("备注不能超过255个字！");
        return;
      }
      if (!this.addParams.updateFlg) {
        Vue.prototype.$valertbar.show("请输入更新标识");
        return;
      }
      if (!this.addParams.enableFlg) {
        Vue.prototype.$valertbar.show("请输入启用标识");
        return;
      }
      this.add();
    },
    async add() {
      var param = {
        appId: this.addParams.appId,
        appType: this.addParams.appType,
        version: this.addParams.version,
        remarks: this.addParams.remarks,
        fileUrl: this.addParams.fileUrl,
        updateFlg: this.addParams.updateFlg,
        enableFlg: this.addParams.enableFlg,
      };
      const data = await saveVersion(param);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.upConfirmSuccess();
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    handleEdit() {
      if (!this.addParams.appId) {
        Vue.prototype.$valertbar.show("请输入APP标识");
        return;
      }
      if (!this.addParams.appType) {
        Vue.prototype.$valertbar.show("请输入手机类型");
        return;
      }
      if (!this.addParams.version) {
        Vue.prototype.$valertbar.show("请输入版本号");
        return;
      }
      if (!this.addParams.remarks) {
        Vue.prototype.$valertbar.show("请输入备注");
        return;
      }
      if (this.addParams.remarks.length > 255) {
        Vue.prototype.$valertbar.show("备注不能超过255个字！");
        return;
      }
      if (!this.addParams.fileUrl) {
        Vue.prototype.$valertbar.show("请输入文件地址");
        return;
      }
      if (!this.addParams.updateFlg) {
        Vue.prototype.$valertbar.show("请输入更新标识");
        return;
      }
      if (!this.addParams.enableFlg) {
        Vue.prototype.$valertbar.show("请输入启用标识");
        return;
      }
      this.edit();
    },
    async edit() {
      var param = {
        id: this.versionId,
        appId: this.addParams.appId,
        appType: this.addParams.appType,
        version: this.addParams.version,
        remarks: this.addParams.remarks,
        fileUrl: this.addParams.fileUrl,
        updateFlg: this.addParams.updateFlg,
        enableFlg: this.addParams.enableFlg,
      };
      const data = await versionUpdate(param);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.upConfirmSuccess();
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    upConfirmSuccess() {
      this.$router.push({
        name: "app-version-management",
      });
    },
    set(value) {
      console.info(value);
      if(value.fileUrl){
        this.addParams.fileUrl = value.fileUrl
      }
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.box1 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
.box2 {
  display: flex;
  // align-items: center;
  margin-top: 30px;
}
.area-class {
  width: 400px;
  height: 80px;
  
}
.flexstart {
  justify-content: flex-start !important;
}
.mr-em {
  margin: 1em 0;
}
.labelClass {
  margin: 0 10px 0 20px;
  text-align: right;
  width: 65px;
}
</style>
